import { formProductLicense, storagePage, tableProducts } from '../storage'
import {
    getProductName,
    getProductBrandName,
    getProductSubcategoryName
} from '../../../utilities/productDisplay'
import setParamsSearch from './setParamsSearch'

export default function build() {
    formProductLicense.init({
        products: storagePage.license.product_licenses
            .filter(pl => pl.memory)
            .map(p => ({
                value: p.product.id.toString(),
                label: getProductName(p.product)
            }))
    })

    const products = storagePage.license.product_licenses
        .filter(pl => pl.memory)
        .map(p => ({
            id: p.product_id,
            product_license_id: p.id,
            product_name: getProductName(p.product),
            brand_name: getProductBrandName(p.product),
            subcategory_name: getProductSubcategoryName(p.product),
            is_enabled: p.is_enabled
        }))

    tableProducts.setList(products)

    storagePage.products.sets(
        storagePage.license.product_licenses.map(
            product_license => product_license.product
        )
    )

    setParamsSearch(true)
}
